import api from '../api/apiClient';

const AI = '/ai-explorer/api/v1';

// Dashboard CRUD
export const getDashboards = (params = {}) => {
  return api.get(`${AI}/ai-explorer/dashboards`, { params });
};

export const getDashboard = (dashboardId) => {
  return api.get(`${AI}/ai-explorer/dashboards/${dashboardId}`);
};

export const createDashboard = (data) => {
  return api.post(`${AI}/ai-explorer/dashboards`, data);
};

export const updateDashboard = (dashboardId, data) => {
  return api.put(`${AI}/ai-explorer/dashboards/${dashboardId}`, data);
};

export const deleteDashboard = (dashboardId) => {
  return api.delete(`${AI}/ai-explorer/dashboards/${dashboardId}`);
};

// Widget management
export const addWidget = (dashboardId, widgetData) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets`, widgetData);
};

export const removeWidget = (dashboardId, widgetId) => {
  return api.delete(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}`);
};

export const generateWidget = (data) => {
  return api.post(`${AI}/ai-explorer/dashboards/generate-widget`, data);
};

export const refreshWidget = (dashboardId, widgetId, timeRange = null) => {
  const params = timeRange ? { time_range: timeRange } : {};
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}/refresh`, null, { params });
};

// Full dashboard generation
export const generateFullDashboard = (data) => {
  return api.post(`${AI}/ai-explorer/dashboards/generate`, data, { timeout: 180000 });
};

// ── Saf3AI Agent canvas ────────────────────────────────────────────────────

/** Make a freshly pinned tile redrawable (resolves its question; live or snapshot). */
export const prepareWidget = (dashboardId, widgetId, data) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}/prepare`, data, { timeout: 60000 });
};

/** Redraw a live tile for the caller (filters and time window applied; nothing saved). */
export const renderWidget = (dashboardId, widgetId, { timeRange, focus } = {}) => {
  const params = {};
  if (timeRange) params.time_range = timeRange;
  if (focus?.type && focus?.value) { params.focus_type = focus.type; params.focus_value = focus.value; }
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}/render`, null, { params });
};

/** Change a tile in words, in place (keeps a version) or as a new tile. */
export const askWidget = (dashboardId, widgetId, instruction, asNew = false) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}/ask`, { instruction, as_new: asNew }, { timeout: 120000 });
};

export const restoreWidgetVersion = (dashboardId, widgetId, index) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/widgets/${widgetId}/versions/${index}/restore`);
};

/** Write or rewrite the canvas summary tile (one model call). */
export const writeCanvasSummary = (dashboardId) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/summary`, null, { timeout: 60000 });
};

/** Ask a question on the canvas and add the answer as a new tile (2 model calls). */
export const addTileFromQuestion = (dashboardId, question) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/tiles`, { question }, { timeout: 120000 });
};

/** Answer a question from what the canvas shows (1 model call, nothing saved). */
export const askCanvas = (dashboardId, question) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/question`, { question }, { timeout: 60000 });
};

/** Three questions that would add something the canvas doesn't show yet. */
export const suggestTiles = (dashboardId) => {
  return api.post(`${AI}/ai-explorer/dashboards/${dashboardId}/suggestions`, null, { timeout: 60000 });
};
